import { render, staticRenderFns } from "./OrderCheckout.vue?vue&type=template&id=c547fdca&scoped=true&"
import script from "./OrderCheckout.vue?vue&type=script&lang=js&"
export * from "./OrderCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c547fdca",
  null
  
)

export default component.exports